var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "changelog-entry" }, [
    _c(
      "div",
      {
        staticClass: "changelog-entry__action",
        class: _vm.viewData.actionClass
      },
      [
        _c("i", {
          staticClass: "fa changelog-entry__action-icon",
          class: {
            "fa-plus-circle": _vm.viewData.actionText === "created",
            "fa-pencil": _vm.viewData.actionText === "updated",
            "fa-minus-circle": _vm.viewData.actionText === "deleted"
          }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "changelog-entry__summary" },
      [
        _vm._t("default", function() {
          return [
            _c(
              "div",
              {
                staticClass: "changelog-entry__info",
                attrs: { "data-testid": "changelog-entry-statement" }
              },
              [_c("ChangeLogParts", { attrs: { parts: _vm.statement } })],
              1
            )
          ]
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "changelog-entry__date",
          domProps: { textContent: _vm._s(_vm.shortTime) }
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }